import { EventInfoType } from '@amzn/ring-web-analytics';
import { mapEventToRWA, EVENT_TYPE_MAP } from 'src/shared/services/RWA/utils';

export interface EventOptions {
  resourceId: string;
  type: EventInfoType;
  resourceName: string;
}

export const trackAnalyticsEvent = (e: string, _properties?: Object) => {
  if (!window.RWA || !EVENT_TYPE_MAP[e]) return;

  try {
    const rwaEvent = mapEventToRWA(e);
    window.RWA.recordEvent(rwaEvent);
  } catch (error) {
    console.error('RWA tracking failed:', error);
  }
};

export const trackEventWithOptions = (options: EventOptions) => {
  if (!window.RWA) return;

  try {
    window.RWA.recordEvent(options);
  } catch (error) {
    console.error('RWA tracking failed:', error);
  }
};

export const setPageTitle = (title: string) => {
  window.RWA?.updateCurrentPageTitle(title);
};

export const flushAnalytics = () => {
  window.RWA?.flush();
};
